import { Link, useLocation } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { PageHeader } from "@/pages/layoutChrome";
import CheckIdValidator from "@/components/checkid/CheckIdValidator";
import ModuleClientSelector from "@/components/ModuleClientSelector";
import { VALIDADOR_DATOS_CHECK_ID_LABEL } from "@/lib/checkIdLabels";
import {
  resolveDatosMaestrosAwareBreadcrumb,
  resolveDatosMaestrosReturnTarget,
} from "@/modules/datosMaestros/datosMaestrosNavigation";
import { useDatosMaestrosNavigationContext } from "@/modules/datosMaestros/useDatosMaestrosNavigationContext";

const CONTEXT_LABEL = "Asistente Laboral y REPSE";

/**
 * Pantalla Check ID del trabajador — acceso canónico desde Datos Maestros.
 */
export default function CheckIdDatosMaestrosScreen({ testId = "datos-maestros-validador-check-id-page" }) {
  const location = useLocation();
  useDatosMaestrosNavigationContext();
  const returnTo = resolveDatosMaestrosReturnTarget(location, "/datos-maestros");
  const returnLabel =
    location.state?.returnLabel
    || (returnTo.includes("panel=datos-maestros") ? "Volver al Panel General" : "Volver a Datos Maestros");

  return (
    <div className="space-y-0 min-h-full" data-testid={testId}>
      <PageHeader
        title={VALIDADOR_DATOS_CHECK_ID_LABEL}
        subtitle="Check ID del trabajador: RFC, CURP, NSS y consistencia antes del alta o inscripción IMSS."
        breadcrumb={resolveDatosMaestrosAwareBreadcrumb(
          location,
          CONTEXT_LABEL,
          VALIDADOR_DATOS_CHECK_ID_LABEL,
        )}
      />

      <div className="px-8 py-6 w-full max-w-none space-y-6">
        <Link
          to={returnTo}
          className="inline-flex items-center gap-2 rounded-sm border border-[#0F2D5C]/25 bg-[#0F2D5C]/[0.04] px-3 py-1.5 text-xs font-semibold text-[#0F2D5C] shadow-sm hover:bg-[#0F2D5C]/10"
          data-testid="back-to-datos-maestros"
        >
          <ArrowLeft className="w-4 h-4 shrink-0" strokeWidth={2.25} />
          {returnLabel}
        </Link>

        <ModuleClientSelector variant="panel" className="mb-2" />

        <CheckIdValidator variant="laboral" />
      </div>
    </div>
  );
}
